import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Creators } from "@ReduxStore/actionTypes";
import { ROUTES } from "@Src/constants";

/**
 * useChannelViewMore Hook
 * @returns {function} handleViewMore() function to handle view more link click.
 */
export function useChannelViewMore() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewMore = (linkType, linkKey) => {
    if (!linkType || !linkKey) return;

    let route = ROUTES.SEARCH_PATH;
    const setupSearch = (type) => {
      dispatch(Creators.viewMoreReset());
      dispatch(Creators[type](linkKey));
    };

    switch (linkType) {
      case "keyword":
        setupSearch("selectKeyword");
        break;
      case "phrase":
        setupSearch("selectPhrase");
        break;
      case "category":
        setupSearch("selectCategory");
        break;
      case "subcategory":
        setupSearch("selectSubCategory");
        break;
      case "onlinedeals":
        setupSearch("filterChangingOnline");
        break;
      case "sort":
        setupSearch("filterChangingHowToSort");
        break;
      case "internal":
        route = `${ROUTES.DIRECTOR_PATH}?${linkKey}`;
        break;
      default:
        return null;
    }

    navigate(route);
  };

  return {
    handleViewMore,
  };
}
